import { render, staticRenderFns } from "./KarmaProgramAddForm.vue?vue&type=template&id=e4e55e60&scoped=true&"
import script from "./KarmaProgramAddForm.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramAddForm.vue?vue&type=script&lang=js&"
import style0 from "./KarmaProgramAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaProgramAddForm.vue?vue&type=style&index=1&id=e4e55e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e55e60",
  null
  
)

export default component.exports